import { render, staticRenderFns } from "./ClientImporter.vue?vue&type=template&id=2efebcf4&scoped=true&"
import script from "./ClientImporter.vue?vue&type=script&lang=js&"
export * from "./ClientImporter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efebcf4",
  null
  
)

export default component.exports